<template>
    <popup-modal
        class="w-768"
        :title="$t('general.preview_mail')"
        @close="$emit('close')"
    >
        <p v-if="description"
           class="text-primary-80 mr-32 mb-16">
            {{ description }}
        </p>

        <loading v-if="!content" class="pt-24" size="medium"></loading>
        <div v-else
             v-html="content"
        ></div>
    </popup-modal>
</template>

<script>

import PopupModal from './components/ui/PopupModal';
import Loading from './components/ui/Loading';

export default {
    components: {Loading, PopupModal},
    props: {
        content: null,
        description: {type: String, default: ''},
    },
};
</script>
